export const formularioTipoLancamentoParceiroStyles = {}
